<script setup lang="ts">
/**
 * Нижнее меню Портала лояльности (макет bnav): Главная/Акции/Карта/Миссии/Ещё.
 * НЕ магазинное (Каталог/Корзина) — Портал открывается по launch-токену, магазинная
 * навигация неприменима. Токен пробрасываем в каждую ссылку (?token=…), чтобы переходы
 * между экранами Портала сохраняли авторизацию.
 */
import { computed } from "vue";
import { useRoute } from "vue-router";

const route = useRoute();
const token = computed(() => String(route.query.token ?? ""));
const q = computed(() => (token.value ? `?token=${encodeURIComponent(token.value)}` : ""));

interface Item { to: string; label: string; icon: string; match: (p: string) => boolean }
const items: Item[] = [
  { to: "/my-loyalty", label: "Главная", icon: "🏠", match: (p) => p === "/my-loyalty" },
  { to: "/offers", label: "Акции", icon: "🏷️", match: (p) => p.startsWith("/offers") },
  { to: "/card", label: "Карта", icon: "💳", match: (p) => p.startsWith("/card") },
  { to: "/missions-portal", label: "Миссии", icon: "🎯", match: (p) => p.startsWith("/missions-portal") },
  { to: "/portal-more", label: "Ещё", icon: "☰", match: (p) => p.startsWith("/portal-more") || p.startsWith("/shared-wallet") || p.startsWith("/referral") || p.startsWith("/promo") || p.startsWith("/order-history") },
];
</script>

<template>
  <nav class="ltab">
    <a v-for="it in items" :key="it.to" :href="`${it.to}${q}`" class="lt" :class="{ act: it.match(route.path) }" :data-test="`ltab-${it.label}`">
      <span class="lt-ic">{{ it.icon }}</span>
      <span class="lt-t">{{ it.label }}</span>
    </a>
  </nav>
</template>

<style scoped>
.ltab {
  position: sticky; bottom: 0; left: 0; right: 0; z-index: 30;
  display: grid; grid-template-columns: repeat(5, 1fr);
  padding: 8px 4px calc(10px + env(safe-area-inset-bottom));
  background: color-mix(in srgb, var(--vd-card, #fff) 92%, transparent);
  backdrop-filter: blur(8px);
  border-top: 1px solid rgba(127, 127, 127, 0.2);
}
.lt {
  display: flex; flex-direction: column; align-items: center; gap: 3px;
  text-decoration: none; color: var(--vd-faint, #9a9aae); font-size: 10px; font-weight: 600;
}
.lt.act { color: var(--brand, var(--vd-brand, #2e9e5b)); }
.lt-ic { font-size: 19px; line-height: 1; }
</style>
